var _path, _path2, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 62,
    viewBox: "0 0 65 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9149 6H9.08508C4.06753 6 0 10.0675 0 15.0851V52.9149C0 57.9325 4.06753 62 9.08508 62H46.9149C51.9325 62 56 57.9325 56 52.9149V15.0851C56 10.0675 51.9325 6 46.9149 6Z",
    fill: "#B9E2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9888 39.9829C65.0167 47.606 58.7872 53.8773 51.1641 53.9052L25.0059 53.9888C17.3829 54.0167 11.1116 47.7872 11.0837 40.1641L11.0001 14.0059C10.9722 6.38284 17.2017 0.111579 24.8248 0.0837067L50.9829 9.31685e-05C58.606 -0.0277792 64.8773 6.20168 64.9052 13.8248L64.9888 39.9829Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2076_3807",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.9023,
    y: 11.9626,
    width: 29.3657,
    height: 29.3657,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2076_3807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0924 35.2105C43.9489 35.2105 44.6728 34.9148 45.2642 34.3234C45.8556 33.732 46.1513 33.0081 46.1513 32.1516C46.1513 31.2951 45.8556 30.5711 45.2642 29.9797C44.6728 29.3883 43.9489 29.0926 43.0924 29.0926C42.2359 29.0926 41.512 29.3883 40.9206 29.9797C40.3292 30.5711 40.0335 31.2951 40.0335 32.1516C40.0335 33.0081 40.3292 33.732 40.9206 34.3234C41.512 34.9148 42.2359 35.2105 43.0924 35.2105ZM49.3326 40.1048L46.029 36.8317C45.6007 37.0968 45.1368 37.3008 44.6372 37.4435C44.1375 37.5863 43.6226 37.6576 43.0924 37.6576C41.5629 37.6576 40.2629 37.1223 39.1923 36.0517C38.1216 34.9811 37.5863 33.681 37.5863 32.1516C37.5863 30.6221 38.1216 29.3221 39.1923 28.2514C40.2629 27.1808 41.5629 26.6455 43.0924 26.6455C44.6219 26.6455 45.9219 27.1808 46.9925 28.2514C48.0631 29.3221 48.5985 30.6221 48.5985 32.1516C48.5985 32.7022 48.522 33.2273 48.369 33.7269C48.2161 34.2265 48.0071 34.6905 47.742 35.1187L51.0456 38.3918L49.3326 40.1048ZM29.0214 38.8812C28.3484 38.8812 27.7723 38.6416 27.2931 38.1623C26.8138 37.6831 26.5742 37.107 26.5742 36.4341V16.857C26.5742 16.184 26.8138 15.6079 27.2931 15.1287C27.7723 14.6494 28.3484 14.4098 29.0214 14.4098H38.8099L46.1513 21.7512V24.8102C45.6619 24.6062 45.1623 24.4533 44.6524 24.3513C44.1426 24.2494 43.6226 24.1984 43.0924 24.1984C40.5841 24.1984 38.6213 25.0294 37.204 26.6914C35.7867 28.3534 35.078 30.2041 35.078 32.2433C35.078 33.5077 35.3788 34.7313 35.9804 35.914C36.582 37.0968 37.5354 38.0859 38.8405 38.8812H29.0214ZM37.5863 22.9748H43.7042L37.5863 16.857V22.9748Z",
    fill: "#0D5DA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.da352f5c28c67c8fb5f64356fed3af05.svg";
export { ForwardRef as ReactComponent };